/*
 * Copyright © 2018-2026, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import { PetSpecies } from "../pet/PetSpeciesEnum";

export enum PetVetDataSpeciesCategory {
  CAT = "CAT",
  DOG = "DOG",
  FERRET = "FERRET",
  GUINEA_PIG = "GUINEA_PIG",
  HAMSTER = "HAMSTER",
  HORSE = "HORSE",
  MONKEY = "MONKEY",
  PARROT = "PARROT",
  RABBIT = "RABBIT",

  OTHER = "OTHER",
}

/* TODO: remove later 
nyúl
macska
kutya
vadászgörény
majom
papagáj
tengerimalac
hörcsög
ló
egyéb állat
*/
export function transformStringToPetSpecies(species?: string): PetSpecies {
  switch (species?.toLowerCase()) {
    case "kutya":
      return PetSpecies.DOG;
    case "macska":
      return PetSpecies.CAT;
    case "tengerimalac":
      return PetSpecies.GUINEA_PIG;
    case "hörcsög":
      return PetSpecies.HAMSTER;
    case "ló":
      return PetSpecies.HORSE;
    case "majom":
      return PetSpecies.ZOO_ANIMAL;
    case "papagáj":
      return PetSpecies.BIRD;
    case "nyúl":
      return PetSpecies.RABBIT;
    case "vadászgörény":
      return PetSpecies.FERRET;  
    default:
      return PetSpecies.OTHER;
  }
}
